import React from 'react';
import { Link } from 'react-router-dom';

const Blog: React.FC = () => {
  return (
    <div className="container-fluid blog py-5">
      <div className="container py-5">
        <div className="d-flex flex-column mx-auto text-center mb-5 wow fadeInUp" data-wow-delay="0.2s"
          style={{ maxWidth: "800px" }}>
          <h4 className="text-primary">Our Blog</h4>
          <h1 className="display-4 mb-4">News & Updates</h1>
          <p className="mb-0">Explore insights, trends, and expert tips on water and wastewater treatment. Stay
            updated with the latest innovations, case studies, and sustainable solutions from industry leaders
            at Wasser Technochem.
          </p>
        </div>
        <div className="row g-4">
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
            <div className="blog-item">
              <div className="blog-img">
                <img src="img/commercial-1.jpg" className="img-fluid w-100" alt="" />
              </div>
              <div className="blog-heading">
                <Link to="/water-treatment-project-execution" className="h4 mb-0 p-4">Complex Water Treatment System — Project Execution
                  Excellence</Link>
              </div>
              <div className="blog-content bg-light p-4">
                <div className="d-flex justify-content-between mb-4">
                  <p className="mb-0 small"><i className="fa fa-calendar me-2"></i> April 2,2025</p>
                  <p className="mb-0 small"><i className="fa fa-tag me-2"></i><strong>Industry:</strong> Power
                    Plant</p>
                </div>
                <p className="mb-4 blog-text">WTIL successfully executed a turnkey water treatment project for a large
                  power plant, integrating
                  advanced systems like RO, UF, and Mixed Bed units. The solution improved water quality,
                  enhanced
                  efficiency, and reduced operational costs.
                </p>
                <Link className="btn btn-primary py-2 px-4" to="/water-treatment-project-execution">Learn More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.4s">
            <div className="blog-item">
              <div className="blog-img">
                <img src="img/commercial-2.jpg" className="img-fluid w-100" alt="" />
              </div>
              <div className="blog-heading">
                <Link to="/boiler-water-treatment" className="h4 mb-0 p-4">Boiler Water Treatment — Enhanced Performance with AVT</Link>
              </div>
              <div className="blog-content bg-light p-4">
                <div className="d-flex justify-content-between mb-4">
                  <p className="mb-0 small"><i className="fa fa-calendar me-2"></i> April 2,2025</p>
                  <p className="mb-0 small"><i className="fa fa-tag me-2"></i><strong>Industry:</strong> Cement
                  </p>
                </div>
                <p className="mb-4 blog-text">WTIL implemented its proprietary SANYOL® AVT solution at a cement plant to
                  address boiler scaling,
                  corrosion, and pH imbalance. The treatment improved efficiency by 20%, reduced downtime,
                  cut fuel costs, and
                  extended equipment life.
                </p>
                <Link className="btn btn-primary py-2 px-4" to="/boiler-water-treatment">Learn More</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.6s">
            <div className="blog-item">
              <div className="blog-img">
                <img src="img/commercial-3.jpg" className="img-fluid w-100" alt="" />
              </div>
              <div className="blog-heading">
                <Link to="/smart-water-treatment-system" className="h4 mb-0 p-4">Application of New Technology — Design and Execution of a
                  Smart Water Treatment System</Link>
              </div>
              <div className="blog-content bg-light p-4">
                <div className="d-flex justify-content-between mb-4">
                  <p className="mb-0 small"><i className="fa fa-calendar me-2"></i> April 2,2025</p>
                  <p className="mb-0 small"><i className="fa fa-tag me-2"></i><strong>Industry:</strong> Textile
                  </p>
                </div>
                <p className="mb-4 blog-text">WTIL implemented a smart wastewater treatment system for a textile plant
                  using IoT and AI. The solution
                  improved efficiency, reduced chemical use by 25%, enhanced compliance, and enabled
                  real-time monitoring and
                  predictive maintenance.
                </p>
                <Link className="btn btn-primary py-2 px-4" to="/smart-water-treatment-system">Learn More</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
